/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  RankingAtualizado,
  ItemRanking,
  UserLogado,
  LogoMinhaBunge,
  DivItemNoticia,
  BgImgNoticia,
  DivBtsNoticiaNovidades,
  BtNoticiaNovidades,
  BtNoticiaNovidadesSelecionado,
  BtVoltar
} from './Estilos'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function Ranking(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ Tipo, setTipo ] = useState(localStorage.getItem("c_tipo"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Ranking")
        PegaRanking();
    }
  }, []);


  const [TipoLista, setTipoLista] = useState("");
  const [TextoListaRanking, setTextoListaRanking] = useState("");
  const [ListaRanking, setListaRanking] = useState([]);

  async function PegaRanking() {
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");


    var raw = JSON.stringify({});

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Ranking/ListarTrimestral`, requestOptions)
    .then(response => response.json())
    .then(result => {
      console.log(result);

      if(result.sucesso === true) {
        setListaRanking(result.listaTrimestral);
        setTipoLista(true)
      } else {
        setTextoListaRanking(result.mensagem);
        setTipoLista(false)
      }

      setLoading(false);

    })
      .catch(error => console.log('error', error));
    
  }


  
  function DataOntem() {
    var hoje = new Date();
    var ontem = new Date(hoje.getTime());
    ontem.setDate(hoje.getDate() - 1);
    var dd = ontem.getDate();
    var mm = ontem.getMonth()+1; 
    var yyyy = ontem.getFullYear();
    if(dd<10) { dd='0'+dd; }
    if(mm<10) { mm='0'+mm; } 
    return dd +'/'+ mm +'/'+ yyyy;
  }


  function DadosUsuario(item, index) {
    return <>
    <div className={'ImgAvatar'}> <img src={item.avatarTri} width="100" height="100" alt="" /> </div>
    <div className={'DadosUsuario'}>
      <div className={'PosicaoPontos'}>
        <div>
          {item.rank}º
          {item.rank === 1 ? '🏆' : null}
          {item.rank === 2 ? '🥈' : null}
          {item.rank === 3 ? '🥉' : null}
        </div>
        <div>{item.pontos}</div>
      </div>
      <div className={'NomeUser'}>{item.nome}</div>
    </div>
    </>
  }


  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        {/* <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}> */}

            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Ranking</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <br/>
                    <Clear />

                    {TipoLista === true ?
                      <>
                        <RankingAtualizado>Ranking atualizado até <span>{DataOntem()}</span> </RankingAtualizado>

                      { ListaRanking.map((item, index) => {                    
                        if(item.entidadeId == IdUser) {                    
                          return <> <UserLogado> {DadosUsuario(item, index)} </UserLogado> </>                      
                        } else {                    
                          return <> <ItemRanking> {DadosUsuario(item, index)} </ItemRanking> </>
                        }
                      }) }
                    <RankingAtualizado style={{margin: '5px auto', maxWidth: 400}}>
                      { Tipo == '2479' ?
                      <>Lembre-se que para participar do ranking é necessário ter <strong style={{color: '#043c54', fontWeight: '700'}}>40</strong> pesquisas em clientes distintos, no trimestre.</>
                      : null }
                      { Tipo == '2277' ?
                      <>Lembre-se que para participar do ranking é necessário ter <strong style={{color: '#043c54', fontWeight: '700'}}>10</strong> pesquisas em clientes distintos, no trimestre.</>
                      : null }
                    </RankingAtualizado>
                      </>
                    : null }

                    {TipoLista === false ? <div>{TextoListaRanking}</div> : null }

                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default Ranking;
